/**
 * UsuariosRede.tsx — Gestão de equipe do painel de rede.
 * Usa o componente genérico EquipeManager com REDE_CONFIG.
 */
import { EquipeManager, buildRedeConfig } from '../../components/equipe';
import { useAuthStore } from '../../store/authStore';

export function UsuariosRede() {
  const redeId = useAuthStore((s) => s.user?.redeId);

  if (!redeId) {
    return (
      <div className="admin-page" style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>
        Nenhuma rede vinculada ao seu perfil.
      </div>
    );
  }

  return <EquipeManager config={buildRedeConfig(redeId)} />;
}
